export const GET_CHANGE_LOGS_BY_OBJECT = 'getChangeLogsByObject';
export const GET_CHANGE_LOGS_BY_USERNAME = 'getChangelogByUsername';
export const GET_CHANGE_LOGS = 'getChangelog';
export const CLEAR_LOGS = 'clearLogs';